import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { FaBlog, FaRobot, FaGlobe } from "react-icons/fa";
import HeroCell from "./HeroCell";
import AboutCell from "./AboutCell";
import SocialCell from "./SocialCell";
import CvDownloadCell from "./CvDownloadCell";
import StatsCell from "./StatsCell";
import KairiaCell from "./KairiaCell";
import SkillsCell from "./SkillsCell";
import ProjectCell from "./ProjectCell";
import ExperienceCell from "./ExperienceCell";
import ContactCell from "./ContactCell";

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.08 },
  },
};

const BentoGrid = () => {
  const { t } = useTranslation();

  return (
    <section id="home" className="pt-28 pb-8">
      <motion.div
        variants={container}
        initial="hidden"
        animate="show"
        className="grid grid-cols-1 md:grid-cols-2 lgl:grid-cols-12 gap-4 lgl:auto-rows-[minmax(80px,auto)]"
      >
        {/* Row 1-3 */}
        <HeroCell />
        <AboutCell />
        <SocialCell />
        <CvDownloadCell />
        <StatsCell />

        {/* Row 4-5: Featured project + Skills */}
        <KairiaCell />
        <SkillsCell />

        {/* Row 6-7: Projects */}
        <ProjectCell
          title={t("projects.projectFourTitle")}
          description={t("projects.projectFourDesc")}
          url="https://pilotranker.com/"
          icon={<FaBlog />}
          className="lgl:col-start-1 lgl:col-end-5 lgl:row-start-6 lgl:row-end-8"
        />
        <ProjectCell
          title={t("projects.projectTwoTitle")}
          description={t("projects.projectTwoDesc")}
          url="https://smart-ai-reply.com/"
          icon={<FaRobot />}
          className="lgl:col-start-5 lgl:col-end-9 lgl:row-start-6 lgl:row-end-8"
        />

        {/* Row 8-9: Experience + GuruDeals + Contact */}
        <ExperienceCell />
        <ProjectCell
          title={t("projects.projectOneTitle")}
          description={t("projects.projectOneDesc")}
          url="https://gurudeals.fr/"
          icon={<FaGlobe />}
          className="lgl:col-start-7 lgl:col-end-10 lgl:row-start-8 lgl:row-end-10"
        />
        <ContactCell />
      </motion.div>
    </section>
  );
};

export default BentoGrid;
